import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

const DropDownButtonIcon = (props: any) => {
  const {
    textButton = "",
    icon = "",
    active = false,
    handleClickAction = () => {},
    dropdownItems = props.dropdownItems ?? [],
  } = props;

  return (
    <DropdownButton
      className={`btn btnHeader`}
      title={
        <>
          {icon && <span className="material-symbols-outlined">{icon}</span>}
          <span> {textButton}</span>
        </>
      }
    >
      {dropdownItems.map((dropdownItem: any, index: number) => (
        <Dropdown.Item key={index}>
          <div onClick={handleClickAction}>{dropdownItem?.title}</div>
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default DropDownButtonIcon;
